import React, {PureComponent} from 'react'
import styles from './styles'
import { FormContext } from 'components'
import {DialogHandler} from 'utils'
import { InputDialog } from 'components/InputDialog'
import {FileUploadField, ReadOnly} from 'components'
import {Typography, Button, TextField, IconButton} from 'components/OptimisedMui'
import Checkbox from 'components/styled/Checkbox'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { paramScoped, uuid } from 'utils'

export class Documents extends PureComponent {
  static defaultProps = {
    name: 'Documents',
    title: 'Supporting documents',
  }

  state = {}
  downloadDialogHandler = new DialogHandler(this, 'downloadDialog')

  handleAddDownload = async() => {
    const {onChange, context} = this.props
    const name = await this.downloadDialogHandler.show()
    if (name) {
      onChange({...context, downloads: [...context.downloads, {name, key: uuid(), documentUrl: ''}]})
    }
  }

  handleRenameDownload = paramScoped(download => async() => {
    const {onChange, context} = this.props
    const name = await this.downloadDialogHandler.show({initialValue: download.name})
    if (name)
      onChange({...context, downloads: context.downloads.map(d => d === download ? {...d, name} : d)})
  })

  handleDeleteDownload = paramScoped(download => event => {
    const {onChange, context} = this.props
    onChange({...context, downloads: context.downloads.filter(d => d !== download)})
  })

  deleteIcon = <DeleteIcon/>
  editIcon = <EditIcon/>

  render = () => {
    const {onChange, context, errorContext, review} = this.props
    return (
      <ReadOnly on={review}>
        <FormContext
          onChange={onChange}
          context={context}
          errorContext={errorContext}
          metaRef={this.props.metaRef}
        >
          <Typography variant="subtitle1" className={styles.nestedHeading}>Supported file type: .PDF</Typography>

          {context.downloads.map((download, i) =>
            <div key={download.name} className={styles.section}>
              <div className={styles.headerRow}>
                <Typography variant='h6'>
                  {download.name}
                </Typography>
                <span className={styles({note: true, disabled: !context.downloads[i].private})}>
                  (<Checkbox className={styles.textCheckbox} member={`downloads[${i}].isPrivate`} type="checkbox" />For {process.env.REACT_APP_NAME} Info Only)
                </span>
                <div style={{flex: 1}} />
                <IconButton onClick={this.handleRenameDownload(download)}>{this.editIcon}</IconButton>
                <IconButton onClick={this.handleDeleteDownload(download)}>{this.deleteIcon}</IconButton>
              </div>

              <TextField member={`downloads[${i}].description`}
                         errorMember={`downloads['${download.key}'].description`}
                         meta={{errorLabel: `${download.name} Description`}}
                         label="Please enter a short description of the document" fullWidth multiline />
              <FileUploadField member={`downloads[${i}].attachment`}
                               errorMember={`downloads['${download.key}'].attachment`}
                               meta={{errorLabel: `${download.name} Attachment`}}
                               type='file' fullWidth/>
              <Typography variant="subtitle1">or use External Document</Typography>
              <TextField member={`downloads[${i}].documentUrl`}
                         meta={{errorLabel: `${download.name} External Document URL`}}
                         errorMember={`downloads['${download.key}'].documentUrl`} label="External Document URL" fullWidth />
            </div>
          )}
          <InputDialog {...this.downloadDialogHandler.props} title="Document name" label="Document name" valueRequired/>
          <Button vaiant="contained" className={styles.addButton} onClick={this.handleAddDownload} fullWidth>Add Another Document</Button>

        </FormContext>
      </ReadOnly>
    )
  }
}

export default Documents